import Swiper, { Pagination } from 'swiper'

Swiper.use([Pagination])

import swiperHandleKeyboardFocus from '@js/util/swiper-handle-keyboard-focus'

for (let sliderElement of document.querySelectorAll('.testimonial-slider')) {
  let swiper = new Swiper(
    `#${sliderElement.dataset.swiperId}`,
    JSON.parse(sliderElement.dataset.options),
  )
  swiperHandleKeyboardFocus(swiper)
}
